import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { APAEvaluationViewModel, CourseEventViewModel } from 'src/app/_models/generatedModels';
import { EventService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-apa-assessment-modal',
  templateUrl: 'apa-assessment-modal.component.html',
})
export class ApaAssessmentModalComponent implements OnInit {
  initialized = false;
  @Input() courseEventId: number;
  errorMessage: string;
  submitComplete: Promise<{}> | undefined;

  @ViewChild('myForm') myForm: FormGroupDirective;

  courseEvent: CourseEventViewModel;
  model: APAEvaluationViewModel;
  constructor(private eventService: EventService, public modal: NgbActiveModal, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.model = new APAEvaluationViewModel();
    this.eventService.getSpecificCourseEvent(this.courseEventId.toString()).subscribe((course) => {
      this.courseEvent = course;
      this.initialized = true;
    });
  }

  onSave() {
    if (!this.myForm.valid) {
      this.myForm.form.markAllControlsDirty();
      this.errorMessage = 'Please fill out all required fields.';
      return;
    }
    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.eventService.addAPAEvaluation(this.courseEventId, this.model).subscribe((result) => {
        this.modal.dismiss();
        resetButton();
        this.toaster.success('APA Assessment Saved', 'Success');
      },
      (error) => {
        this.errorMessage = error.error[0];
        resetButton();
      });
    });
  }

  public professions: Array<string> = ['Psychologist', 'Administrator', 'Masters Level Associate', 'Student', 'BCBA', 'Medical Professional', 'ESSC Employee', 'Doctoral Level Associate'];
}
